import script from "./ComputationOfIncomeTax.vue?vue&type=script&setup=true&lang=js"
export * from "./ComputationOfIncomeTax.vue?vue&type=script&setup=true&lang=js"

import "./ComputationOfIncomeTax.vue?vue&type=style&index=0&id=f8c448f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8c448f2"]])

export default __exports__